import { createInertiaApp } from "@inertiajs/react";
import { createRoot } from "react-dom/client";
import type { ReactNode } from "react";
import "../styles/index.css";

// Lazy-load page components — each page becomes its own chunk
const pages = import.meta.glob("../pages/**/*.tsx") as Record<
  string,
  () => Promise<{ default: React.ComponentType<Record<string, unknown>> & { layout?: (page: ReactNode) => ReactNode } }>
>;

createInertiaApp({
  resolve: async (name) => {
    const path = `../pages/${name}.tsx`;
    const loader = pages[path];
    if (!loader) {
      console.error(`Page not found: ${name}. Available: ${Object.keys(pages).join(", ")}`);
      const errorModule = await pages['../pages/Error.tsx']!();
      return errorModule;
    }
    const module = await loader();
    return module;
  },
  setup({ el, App, props }) {
    createRoot(el).render(<App {...props} />);
  },
});
